import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetUserAlertsFilteredProvincesService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.getUserAlertsService
   * @param {Object} fromUserAlertsListValueObjectToFilteredProvincesValueObjectMapper
   */
  constructor({config, getUserAlertsService, fromUserAlertsListValueObjectToFilteredProvincesValueObjectMapper}) {
    super({
      config,
      getUserAlertsService,
      fromUserAlertsListValueObjectToFilteredProvincesValueObjectMapper
    })

    this._config = config
    this._getUserAlertsService = getUserAlertsService
    this._fromUserAlertsListValueObjectToFilteredProvincesValueObjectMapper =
      fromUserAlertsListValueObjectToFilteredProvincesValueObjectMapper
  }

  /**
   * @return {Promise<Object, Error>} returns current user alerts
   * @property {UserAlertIdValueObject} userAlertIdValueObject
   * **/

  @inlineError
  async execute({userAlertIdValueObject}) {
    const [error, userAlertsListValueObject] = await this._getUserAlertsService.execute()
    if (error) return Promise.reject(error)

    return this._fromUserAlertsListValueObjectToFilteredProvincesValueObjectMapper.map({
      userAlertIdValueObject,
      userAlertsListValueObject
    })
  }
}
